import {createRouter,createWebHistory} from 'vue-router'
import Home from './pages/home'
import Index from './pages/index'

export default createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            redirect: '/index',
            children: [
                {
                    path: '/index',
                    name: 'index',
                    component: Index,
                    meta:{title:'首页'}
                },
                {
                    path: '/page/:id',
                    name: 'page',
                    component: () => import('./pages/page.vue'),
                    meta:{title:'详情'}
                },
                {
                    path: '/list/:id/:page?',
                    name: 'list',
                    component: () => import('./pages/list.vue'),
                    meta:{title:'列表'}
                },
                {
                    path: '/detail/:catid/:id',
                    name: 'detail',
                    component: () => import('./pages/detail.vue'),
                    meta:{title:'详情'}
                },
                {
                    path: '/international_query',
                    name: 'international_query',
                    component: () => import('./pages/international_query.vue'),
                    meta:{title:'国际快递查询'}
                },
                {
                    path: '/package_ready',
                    name: 'package_ready',
                    component: () => import('./pages/package_ready.vue'),
                    meta:{title:'申请打包'}
                },
                {
                    path: '/count',
                    name: 'count',
                    component: () => import('./pages/count.vue'),
                    meta:{title:'运费计算'}
                },
                {
                    path: '/depot',
                    name: 'depot',
                    component: () => import('./pages/depot.vue'),
                    meta:{title:'仓库地址'}
                },
                {
                    path: '/domestic_query',
                    name: 'domestic_query',
                    component: () => import('./pages/domestic_query.vue'),
                    meta:{title:'国内快递查询'}
                },
                {
                    path: '/question',
                    name: 'question',
                    component: () => import('./pages/question.vue'),
                    meta:{title:'常见问题'}
                },
                {
                    path: '/login',
                    name: 'login',
                    component: () => import('./pages/login.vue'),
                    meta:{title:'登录'}
                },
                {
                    path: '/register',
                    name: 'register',
                    component: () => import('./pages/register.vue'),
                    meta:{title:'注册'}
                },
                {
                    path: '/user',
                    name: 'user',
                    redirect: '/user/index',
                    component: () => import('./pages/user.vue'),
                    children: [
                        {
                            path: '/user/index',
                            name: 'userIndex',
                            component: () => import('./pages/userIndex.vue'),
                            meta:{title:'个人中心'}
                        },
                        {
                            path: '/user/depot',
                            name: 'userDepot',
                            component: () => import('./pages/userDepot.vue'),
                            meta:{title:'仓库地址'}
                        },
                        {
                            path: '/user/package/:status?',
                            name: 'userPackage',
                            component: () => import('./pages/userPackage.vue'),
                            meta:{title:'我的包裹'}
                        },{
                            path: '/user/forecast',
                            name: 'userForecast',
                            component: () => import('./pages/userForecast.vue'),
                            meta:{title:'包裹预报'}
                        },{
                            path: '/user/account',
                            name: 'userAccount',
                            component: () => import('./pages/userAccount.vue'),
                            meta:{title:'个人账号'}
                        },{
                            path: '/user/address',
                            name: 'userAddress',
                            component: () => import('./pages/userAddress.vue'),
                            meta:{title:'我的地址'}
                        },{
                            path: '/user/coupon',
                            name: 'userCoupon',
                            component: () => import('./pages/userCoupon.vue'),
                            meta:{title:'我的优惠券'}
                        },{
                            path: '/user/wallet',
                            name: 'userWallet',
                            component: () => import('./pages/userWallet.vue'),
                            meta:{title:'我的钱包'}
                        },{
                            path: '/user/integral',
                            name: 'userIntegral',
                            component: () => import('./pages/userIntegral.vue'),
                            meta:{title:'我的积分'}
                        },{
                            path: '/user/channel',
                            name: 'userChannel',
                            component: () => import('./pages/userChannel.vue'),
                            meta:{title:'航线渠道'}
                        },
                    ]
                },

                {
                    path: '/order',
                    name: 'order',
                    redirect: '/order/list',
                    component: () => import('./pages/order.vue'),
                    children: [
                        {
                            path: 'list/:status?',
                            name: 'order-list',
                            component: () => import('./pages/orderList.vue'),
                            meta:{title:'订单列表'}
                        },{
                            path: 'detail/id/:id',
                            name: 'order-detail',
                            component: () => import('./pages/orderDetail.vue'),
                            meta:{title:'订单详情'}
                        }
                    ]
                }

            ]
        },
        {
            path: '/mobile',
            name: 'mobileHome',
            component: () => import('./mobile/home'),
            redirect: '/mobile/index',
            children: [
                {
                    path: '/mobile/index',
                    name: 'mobileIndex',
                    component: () => import('./mobile/index'),
                    meta:{title:'首页'}
                },
                {
                    path: '/mobile/page/:id',
                    name: 'm_page',
                    component: () => import('./mobile/page.vue'),
                    meta:{title:'详情'}
                },
                {
                    path: '/mobile/list/:id/:page?',
                    name: 'm_list',
                    component: () => import('./mobile/list.vue'),
                    meta:{title:'列表'}
                },
                {
                    path: '/mobile/detail/:catid/:id',
                    name: 'm_detail',
                    component: () => import('./mobile/detail.vue'),
                    meta:{title:'详情'}
                },
                {
                    path: '/mobile/international_query',
                    name: 'm_international_query',
                    component: () => import('./mobile/international_query.vue'),
                    meta:{title:'国际快递查询'}
                },
                {
                    path: '/mobile/package_ready',
                    name: 'm_package_ready',
                    component: () => import('./mobile/package_ready.vue'),
                    meta:{title:'申请打包'}
                },
                {
                    path: '/mobile/count',
                    name: 'm_count',
                    component: () => import('./mobile/count.vue'),
                    meta:{title:'运费计算'}
                },
                {
                    path: '/mobile/depot',
                    name: 'm_depot',
                    component: () => import('./mobile/depot.vue'),
                    meta:{title:'仓库地址'}
                },
                {
                    path: '/mobile/domestic_query',
                    name: 'm_domestic_query',
                    component: () => import('./mobile/domestic_query.vue'),
                    meta:{title:'国内快递查询'}
                },
                {
                    path: '/mobile/question',
                    name: 'm_question',
                    component: () => import('./mobile/question.vue'),
                    meta:{title:'常见问题'}
                },
                {
                    path: '/mobile/login',
                    name: 'm_login',
                    component: () => import('./mobile/login.vue'),
                    meta:{title:'登录'}
                },
                {
                    path: '/mobile/register',
                    name: 'm_register',
                    component: () => import('./mobile/register.vue'),
                    meta:{title:'注册'}
                },

                {
                    path: '/mobile/user',
                    name: 'm_user',
                    redirect: '/mobile/user/index',
                    component: () => import('./mobile/user.vue'),
                    meta:{title:'我的'},
                    children: [
                        {
                            path: '/mobile/user/index',
                            name: 'm_userIndex',
                            component: () => import('./mobile/userIndex.vue'),
                            meta:{title:'个人中心'}
                        },
                        {
                            path: '/mobile/user/depot',
                            name: 'm_userDepot',
                            component: () => import('./mobile/userDepot.vue'),
                            meta:{title:'仓库地址'}
                        },
                        {
                            path: '/mobile/user/package/:status?',
                            name: 'm_userPackage',
                            component: () => import('./mobile/userPackage.vue'),
                            meta:{title:'我的包裹'}
                        },{
                            path: '/mobile/user/forecast',
                            name: 'm_userForecast',
                            component: () => import('./mobile/userForecast.vue'),
                            meta:{title:'包裹预报'}
                        },{
                            path: '/mobile/user/account',
                            name: 'm_userAccount',
                            component: () => import('./mobile/userAccount.vue'),
                            meta:{title:'个人账号'}
                        },{
                            path: '/mobile/user/address',
                            name: 'm_userAddress',
                            component: () => import('./mobile/userAddress.vue'),
                            meta:{title:'我的地址'}
                        },{
                            path: '/mobile/user/coupon',
                            name: 'm_userCoupon',
                            component: () => import('./mobile/userCoupon.vue'),
                            meta:{title:'我的优惠券'}
                        },{
                            path: '/mobile/user/wallet/:status?',
                            name: 'm_userWallet',
                            component: () => import('./mobile/userWallet.vue'),
                            meta:{title:'我的钱包'}
                        },{
                            path: '/mobile/user/integral',
                            name: 'm_userIntegral',
                            component: () => import('./mobile/userIntegral.vue'),
                            meta:{title:'我的积分'}
                        },{
                            path: '/mobile/user/channel',
                            name: 'm_userChannel',
                            component: () => import('./mobile/userChannel.vue'),
                            meta:{title:'航线渠道'}
                        },
                    ]
                },

                {
                    path: '/mobile/order',
                    name: 'm_order',
                    redirect: '/mobile/order/list',
                    component: () => import('./mobile/order.vue'),
                    children: [
                        {
                            path: 'list/:status?',
                            name: 'm-order-list',
                            component: () => import('./mobile/orderList.vue'),
                            meta:{title:'订单列表'}
                        },{
                            path: 'detail/id/:id',
                            name: 'm-order-detail',
                            component: () => import('./mobile/orderDetail.vue'),
                            meta:{title:'订单详情'}
                        }
                    ]
                }

            ]
        },

    ]
});
